import { createSelector } from "reselect";
import { getFileExtension } from "../../../utils/file";
import { AnnotationsPartialState } from "../reducers/dtos";
import { ImagesEntities } from "../reducers/entities";
import { AnnotationItemExtended, Annotations, Image } from "../types";

export const getImagesEntities = (state: AnnotationsPartialState) => state.imageAnnotations.entities.images;
export const getCurrentAttachmentId = (state: AnnotationsPartialState) => state.imageAnnotations.image.attachmentId;
export const getAttachmentIds = (state: AnnotationsPartialState) => state.imageAnnotations.image.attachmentIds;
export const getAnnotations = (state: AnnotationsPartialState) => state.imageAnnotations.annotations;
export const getAnnotation = (state: AnnotationsPartialState) => state.imageAnnotations.annotation;
export const getProjectId = (state: AnnotationsPartialState) => state.imageAnnotations.messageEditorInfo.projectId;
export const getProjectOrTask = (state: AnnotationsPartialState) =>
    state.imageAnnotations.messageEditorInfo.projectOrTask;
export const getIsAnnotationsPopupOpened = (state: AnnotationsPartialState) => state.imageAnnotations?.popup?.isOpened;

const checkAnnotations = (attachmentId: number, annotations: Annotations) => annotations?.[attachmentId]?.length > 0;

const parseImageTitle = (imageTitle: string) => {
    if (imageTitle && imageTitle.length > 30) {
        const format = getFileExtension(imageTitle);
        return imageTitle.slice(0, 27 - format.length) + "..." + format;
    }
    return imageTitle;
};

type MapAnnotationsList = (
    attachmentId: number,
    annotations: Annotations,
    annotation: AnnotationItemExtended
) => AnnotationItemExtended[];
const mapAnnotationsList: MapAnnotationsList = (attachmentId, annotations, annotation) => {
    const currentAnnotationId = annotation.data?.id;

    return (
        annotations[attachmentId]?.map(annotation => ({
            active: annotation.data.id === currentAnnotationId,
            ...annotation,
        })) || []
    );
};

const getCurrentImageById = (id: number, images: ImagesEntities) => images?.[id] || {};

const getCurrentImageData = ({ source, filename, version, isShowVersion }: Image) => ({
    source,
    filename,
    version,
    isShowVersion,
    title: parseImageTitle(filename),
});

export const getAnnotationsList = createSelector(
    getCurrentAttachmentId,
    getAnnotations,
    getAnnotation,
    mapAnnotationsList
);

export const hasAnnotations = createSelector(getCurrentAttachmentId, getAnnotations, checkAnnotations);

export const getImageData = createSelector(getCurrentAttachmentId, getImagesEntities, getCurrentImageById);

export const getCurrentImage = createSelector(getImageData, getCurrentImageData);
